/* @flow */
import React from 'react';
import ContentSourceProviderForm from './ContentSourceProviderForm';
import ContentSourceProviderPreview from './ContentSourceProviderPreview';

import './styles/ContentSourceProviderPage.scss';

type Props = {
  params: {
    uuid: string,
  },
};

class ContentSourceProviderPage extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);
    this.preview = React.createRef();
  }

  preview: any;

  handleSave = () => {
    if (this.preview.current && this.preview.current.refresh) {
      this.preview.current.refresh();
    }
  };

  render() {
    return (
      <div className="ContentSourceProviderPage">
        <div className="ContentSourceProviderPage-form">
          <ContentSourceProviderForm onSave={this.handleSave} uuid={this.props.params.uuid} />
        </div>
        <div>
          <ContentSourceProviderPreview ref={this.preview} uuid={this.props.params.uuid} />
        </div>
      </div>
    );
  }
}

export default ContentSourceProviderPage;
